module.exports = __webpack_public_path__ + "media/images/b2b_admin/preview_routing_requests-9db0dfcee5d4f785e301fa910cf5bed6.gif";